import {
    AccountingRoleIcon,
    AdminRoleIcon,
    ExtranetIcon,
    ImportRoleIcon,
    SalesRoleIcon,
    ShopAdminRoleIcon,
    ShoppingCartIcon,
    SuluAdminRoleIcon,
    SuperAdminRoleIcon,
    SynergyApiRoleIcon,
    SynergySupplierAdminRoleIcon,
} from '@synergy/theme';
import { Employee, UserRole } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { FunctionComponent } from 'react';
import { PoolTypography } from '@synergy/components';
import { SvgIconProps, Theme, Tooltip, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        gap: '8px',
    },
    disabled: {
        color: theme.palette.grey[800],
    },
    icon: {
        width: 24,
        height: 24,
    },
}));

export interface EmployeeRolesProps {
    employee: Employee;
}

export const EmployeeRoles = (props: EmployeeRolesProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const { employee } = props;

    if (!employee.roles || employee.roles.length === 0) {
        return (
            <PoolTypography
                className={classes.disabled}
                id="app.contactsAndOrganizations.detail.noRoles"
                typography="caption"
            />
        );
    }

    const getColor = (role: UserRole): string | undefined =>
        !employee.roles?.includes(role) ? theme.palette.grey[200] : undefined;

    const iconMap: Record<string, FunctionComponent<SvgIconProps>> = {
        [UserRole.Admin]: AdminRoleIcon,
        [UserRole.SuperAdmin]: SuperAdminRoleIcon,
        [UserRole.Extranet]: ExtranetIcon,
        [UserRole.ShopUser]: ShoppingCartIcon,
        [UserRole.ShopAdmin]: ShopAdminRoleIcon,
        [UserRole.Sales]: SalesRoleIcon,
        [UserRole.Accounting]: AccountingRoleIcon,
        [UserRole.Configuration]: ImportRoleIcon,
        [UserRole.ImportApi]: SynergyApiRoleIcon,
        [UserRole.SuluAdmin]: SuluAdminRoleIcon,
        [UserRole.SupplierAdmin]: SynergySupplierAdminRoleIcon,
    };

    return (
        <div className={classes.container}>
            {Object.entries(iconMap).map(([role, icon]) => (
                <Tooltip title={<FormattedMessage id={`app.role.${role}`} />} placement="bottom" key={role}>
                    <span>{icon({ htmlColor: getColor(role as UserRole), className: classes.icon })}</span>
                </Tooltip>
            ))}
        </div>
    );
};
